import axios from "axios";
import store from "../store";
import { toast } from "react-toastify";
import { setRedirect } from "../actions/rLink.action";
import i18n from "i18next";

const API = axios.create({
  baseURL: `${window.location.origin}/api`,
  responseType: "json",
});

const getInit = async () => {
  try {
    const res = await API.get("/init", {
      withCredentials: false,
    });
    const response = res.data;
    if (response) {
      if (response.uid) {
        API.defaults.headers.common["uid"] = response.uid;
      }
      return response;
    } else return null;
  } catch (err) {
    return null;
  }
};

const post = (path, config = {}) => {
  var { logged } = store.getState().rLink;
  return new Promise(function (resolve, reject) {
    API.post(path, config)
      .then(function (response) {
        return resolve(response);
      })
      .catch(function (error) {
        if (error.response.status === 418) {
          setRedirect("/home");
          if (logged) {
            store.dispatch({ type: "SET_LOGOUT" });
            toast.error(i18n.t("common:getDisconnected"));
          }
        }
        return reject(error);
      });
  });
};

const get = (path, params = {}) => {
  var { logged } = store.getState().rLink;
  return new Promise(function (resolve, reject) {
    API.get(path, {
      params,
    })
      .then(function (response) {
        return resolve(response);
      })
      .catch(function (error) {
        if (error.response.status === 418) {
          if (
            !/bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(
              navigator.userAgent
            )
          )
            setRedirect("/home");
          if (logged) {
            store.dispatch({ type: "SET_LOGOUT" });
            toast.error(i18n.t("common:getDisconnected"));
          }
        }
        return reject(error);
      });
  });
};

const refreshServersAndDevices = () => {
  get("/serversdevices")
    .then((res) => {
      if (res && res.data) {
        store.dispatch({ type: "SET_SERVERS", servers: res.data.servers });
        store.dispatch({ type: "SET_DEVICES", devices: res.data.devices });
      }
    })
    .catch((err) => {
      return err;
    });
};

export const apiServices = {
  getInit,
  post,
  get,
  refreshServersAndDevices,
};
